<script>
  import conciliacaoProjetoServico from '../servico';
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';

  const GRUPOS = [
    { chave: 'aplicacao', titulo: 'Aplicação', tipos: [1, 9] },
    { chave: 'resgate', titulo: 'Resgate', tipos: [2] },
    { chave: 'rendimento', titulo: 'Rendimento', tipos: [3] },
    { chave: 'imposto', titulo: 'IRRF / IOF', tipos: [4, 5, 6] },
    { chave: 'outros', titulo: 'Outros', tipos: [7, 8] },
  ];

  export default {
    components: { DatePicker },
    props: {
      conta: { type: Object, required: true },
    },
    data() {
      return {
        carregando: true,
        erro: '',
        dados: null,
        mostrar: 'ativas',
        selecionada: null,
        carregandoExtrato: false,
        erroExtrato: '',
        extrato: null,
        de: null,
        ate: null,
        tiposMarcados: [],
        grupos: GRUPOS,
        requisicao: 0,
      };
    },
    computed: {
      contaInfo() { return (this.dados && this.dados.conta) || this.conta; },
      aplicacoes() { return (this.dados && this.dados.aplicacoes) || []; },
      qtdeAtivas() { return this.aplicacoes.filter(a => a.ativa).length; },
      visiveis() { return this.mostrar === 'ativas' ? this.aplicacoes.filter(a => a.ativa) : this.aplicacoes; },
      fundos() { return (this.dados && this.dados.fundos) || []; },
      operacoes() { return (this.extrato && this.extrato.operacoes) || []; },
      operacoesVisiveis() {
        if (!this.tiposMarcados.length) return this.operacoes;
        const tipos = this.grupos.filter(g => this.tiposMarcados.indexOf(g.chave) >= 0).reduce((t, g) => t.concat(g.tipos), []);
        return this.operacoes.filter(o => tipos.indexOf(o.tipo) >= 0);
      },
      dataAteTexto() { return this.ate ? moment(this.ate).format('DD/MM/YYYY') : ''; },
    },
    mounted() {
      conciliacaoProjetoServico.aplicacoesConta(this.conta.idContaCript)
        .then(dados => {
          this.dados = dados;
          this.carregando = false;
          if (!this.qtdeAtivas) this.mostrar = 'todas';
          const primeira = this.visiveis[0];
          if (primeira) this.selecionar(primeira);
        })
        .catch(res => {
          this.carregando = false;
          this.erro = res && res.body && res.body.message ? res.body.message : 'Não foi possível carregar as aplicações.';
        });
    },
    methods: {
      cor(v) { return v > 0.004 ? 'v-pos' : v < -0.004 ? 'v-neg' : 'v-zero'; },
      moeda(v) {
        const n = v || 0;
        return (n < -0.004 ? '−' : '') + Math.abs(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      valorOperacao(o) { return (o.creditoDebito === 1 ? '' : '−') + Math.abs(o.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
      qtdeGrupo(g) { return this.operacoes.filter(o => g.tipos.indexOf(o.tipo) >= 0).length; },
      bate() { return Math.abs(this.dados.diferencaFundos || 0) < 0.01; },
      selecionar(a) {
        this.selecionada = a;
        this.tiposMarcados = [];
        this.carregarExtrato();
      },
      alterarMostrar(valor) {
        this.mostrar = valor;
        if (this.selecionada && this.visiveis.indexOf(this.selecionada) < 0 && this.visiveis.length) this.selecionar(this.visiveis[0]);
      },
      carregarExtrato() {
        if (!this.selecionada) return;
        const n = ++this.requisicao;
        const de = this.de ? moment(this.de).format('YYYY-MM-DD') : '';
        const ate = this.ate ? moment(this.ate).format('YYYY-MM-DD') : '';
        this.carregandoExtrato = true;
        this.erroExtrato = '';
        conciliacaoProjetoServico.extratoAplicacao(this.conta.idContaCript, this.selecionada.idAplicacao, de, ate)
          .then(extrato => {
            if (n !== this.requisicao) return;
            this.extrato = extrato;
            this.de = moment(extrato.de, 'YYYY-MM-DD').toDate();
            this.ate = moment(extrato.ate, 'YYYY-MM-DD').toDate();
            this.carregandoExtrato = false;
            this.$nextTick(() => { if (this.$refs.corpoExtrato) this.$refs.corpoExtrato.scrollTop = 0; });
          })
          .catch(res => {
            if (n !== this.requisicao) return;
            this.carregandoExtrato = false;
            this.extrato = null;
            this.erroExtrato = res && res.body && res.body.message ? res.body.message : 'Não foi possível carregar os lançamentos da aplicação.';
          });
      },
      exportar() {
        const num = v => (+(v || 0)).toFixed(2).replace('.', ',');
        const txt = v => '"' + ('' + (v === null || v === undefined ? '' : v)).replace(/"/g, '""') + '"';
        const linhas = [['Data', 'Operação', 'Histórico', 'Valor', 'Complemento', 'Saldo', 'Código'].map(txt).join(';')];
        linhas.push([txt(this.extrato.dataSaldoAnterior), txt('Saldo anterior'), txt(''), txt(''), txt(''), num(this.extrato.saldoAnterior), txt('')].join(';'));
        this.operacoesVisiveis.forEach(o => {
          linhas.push([txt(o.dataTexto), txt(o.tipoTexto), txt(o.historico), num(o.creditoDebito === 1 ? o.valor : -o.valor), txt(o.complemento), num(o.saldo), txt(o.idOperacaoAplicacao)].join(';'));
        });
        const blob = new Blob(['﻿' + linhas.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'aplicacao-' + this.selecionada.idAplicacao + '-' + (this.contaInfo.numeroConta || 'conta') + '.csv';
        link.click();
        URL.revokeObjectURL(url);
      },
    },
  };
</script>

<template>
  <div class="ap-ov">
    <div class="ap-modal">
      <div class="ap-head">
        <h4>Aplicações da conta {{ contaInfo.nomeConta }}</h4>
        <small>{{ contaInfo.nomeBanco }}<template v-if="contaInfo.numeroAgencia"> · Ag {{ contaInfo.numeroAgencia }}</template><template v-if="contaInfo.numeroConta"> · C/C {{ contaInfo.numeroConta }}</template></small>
      </div>

      <div v-if="carregando" class="ap-msg ap-msg-corpo"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
      <div v-else-if="erro" class="ap-msg ap-msg-corpo ap-erro"><i class="fa fa-exclamation-triangle"></i> {{ erro }}</div>

      <div v-else class="ap-corpo">
        <div class="ap-esq">
          <div class="ap-seg">
            <button type="button" :class="{ ativo: mostrar === 'ativas' }" @click="alterarMostrar('ativas')">Ativas <span class="ap-n">{{ qtdeAtivas }}</span></button>
            <button type="button" :class="{ ativo: mostrar === 'todas' }" @click="alterarMostrar('todas')">Todas <span class="ap-n">{{ aplicacoes.length }}</span></button>
          </div>

          <div class="ap-lista">
            <div v-if="!visiveis.length" class="ap-vazio">Nenhuma aplicação {{ mostrar === 'ativas' ? 'ativa ' : '' }}nesta conta.</div>
            <button v-for="a in visiveis" :key="a.idAplicacao" type="button" class="ap-item" :class="{ sel: selecionada === a, inativa: !a.ativa }" @click="selecionar(a)">
              <div class="ap-item-l1">
                <span class="ap-nome" :title="a.nomeTipoAplicacao">{{ a.nomeTipoAplicacao }}</span>
                <span class="ap-saldo mono" :class="cor(a.saldo)">{{ moeda(a.saldo) }}</span>
              </div>
              <div class="ap-item-l2" :title="a.nomeProjeto">{{ a.nomeProjeto || 'Sem projeto' }}</div>
              <div class="ap-item-l3">
                <span>Aplicada em {{ a.dataAplicacaoTexto || '—' }}</span>
                <span v-if="a.dataUltimaOperacaoTexto"> · últ. mov. {{ a.dataUltimaOperacaoTexto }}</span>
              </div>
              <div class="ap-chips" v-if="!a.ativa || a.resgateAutomatico || a.poupanca || a.naoDisponivelProjeto">
                <span v-if="!a.ativa" class="chip chip-cinza">inativa</span>
                <span v-if="a.resgateAutomatico" class="chip chip-azul">resgate automático</span>
                <span v-if="a.poupanca" class="chip chip-azul">poupança</span>
                <span v-if="a.naoDisponivelProjeto" class="chip chip-ambar" title="Não entra no saldo disponível do projeto">não disponível p/ projeto</span>
              </div>
            </button>
          </div>

          <div class="ap-fundos">
            <div class="ap-fundos-tit">
              <span><i class="fa fa-university"></i> Banco<template v-if="dados.dataFundos"> · extrato de {{ dados.dataFundos }}</template></span>
            </div>
            <div v-if="!fundos.length" class="ap-fundos-vazio">O extrato do banco ainda não trouxe a posição dos fundos desta conta.</div>
            <template v-else>
              <div v-for="f in fundos" :key="f.nomeFundo" class="ap-res">
                <span class="ap-fundo-nome" :title="f.nomeFundo">{{ f.nomeFundo }}</span><b class="mono" :class="cor(f.saldo)">{{ moeda(f.saldo) }}</b>
              </div>
              <div class="ap-res total"><span>Total no banco</span><b class="mono" :class="cor(dados.totalBanco)">{{ moeda(dados.totalBanco) }}</b></div>
              <div class="ap-res"><span>Manager em {{ dados.dataFundos }}</span><b class="mono" :class="cor(dados.saldoManagerNaDataFundos)">{{ moeda(dados.saldoManagerNaDataFundos) }}</b></div>
              <div class="ap-res total" :class="bate() ? 'ok' : 'dif'">
                <span>Diferença</span><b class="mono"><i v-if="bate()" class="fa fa-check"></i> {{ moeda(dados.diferencaFundos) }}</b>
              </div>
            </template>
          </div>
        </div>

        <div class="ap-dir">
          <div v-if="!selecionada" class="ap-msg">Selecione uma aplicação.</div>
          <template v-else>
            <div class="ap-sel">
              <div class="ap-sel-nome">{{ selecionada.nomeTipoAplicacao }}</div>
              <div class="ap-sel-info">
                {{ selecionada.nomeProjeto || 'Sem projeto' }}
                <template v-if="selecionada.documento"> · doc. {{ selecionada.documento }}</template>
                <template v-if="selecionada.dataResgateTexto"> · resgate a partir de {{ selecionada.dataResgateTexto }}</template>
                <template v-if="selecionada.complemento"> · {{ selecionada.complemento }}</template>
              </div>
            </div>

            <div class="ap-filtros">
              <div class="ap-filtro">
                <label class="ap-lbl">Período</label>
                <div class="ap-periodo">
                  <span class="ap-dt-box">
                    <date-picker v-model="de" format="DD/MM/YYYY" lang="pt-br" input-class="form-control input-sm ap-dt"
                                 :editable="true" :shortcuts="false" :clearable="false" :append-to-body="true"
                                 :popup-style="{ zIndex: 3200 }" @change="carregarExtrato"></date-picker>
                  </span>
                  <span class="ap-a">a</span>
                  <span class="ap-dt-box">
                    <date-picker v-model="ate" format="DD/MM/YYYY" lang="pt-br" input-class="form-control input-sm ap-dt"
                                 :editable="true" :shortcuts="false" :clearable="false" :append-to-body="true"
                                 :popup-style="{ zIndex: 3200 }" @change="carregarExtrato"></date-picker>
                  </span>
                </div>
              </div>
              <div class="ap-filtro" :title="tiposMarcados.length ? 'O saldo de cada linha continua considerando todas as operações da aplicação' : ''">
                <label class="ap-lbl">Tipo <small v-if="!tiposMarcados.length">(todos)</small></label>
                <div class="ap-tipos">
                  <label v-for="g in grupos" :key="g.chave" class="ap-tipo" :class="{ ativo: tiposMarcados.indexOf(g.chave) >= 0, vazio: !qtdeGrupo(g) }">
                    <input type="checkbox" :value="g.chave" v-model="tiposMarcados"> {{ g.titulo }} <span class="ap-n">{{ qtdeGrupo(g) }}</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="ap-extrato" ref="corpoExtrato">
              <div v-if="carregandoExtrato && !extrato" class="ap-msg"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>
              <div v-else-if="erroExtrato" class="ap-msg ap-erro"><i class="fa fa-exclamation-triangle"></i> {{ erroExtrato }}</div>
              <table v-else-if="extrato" class="ap-tab" :class="{ recarregando: carregandoExtrato }">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Operação</th>
                    <th>Histórico</th>
                    <th class="r">Valor</th>
                    <th>Complemento</th>
                    <th class="r">Saldo</th>
                    <th class="r">Código</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="ap-saldo-linha">
                    <td class="mono">{{ extrato.dataSaldoAnterior }}</td>
                    <td colspan="4">Saldo anterior</td>
                    <td class="r mono" :class="cor(extrato.saldoAnterior)">{{ moeda(extrato.saldoAnterior) }}</td>
                    <td></td>
                  </tr>
                  <tr v-for="o in operacoesVisiveis" :key="o.idOperacaoAplicacao">
                    <td class="mono">{{ o.dataTexto }}</td>
                    <td>{{ o.tipoTexto }}</td>
                    <td class="hist" :title="o.historico">{{ o.historico }}</td>
                    <td class="r mono" :class="o.creditoDebito === 1 ? 'cred' : 'deb'">{{ valorOperacao(o) }}</td>
                    <td class="hist" :title="o.complemento">{{ o.complemento }}</td>
                    <td class="r mono" :class="cor(o.saldo)">{{ moeda(o.saldo) }}</td>
                    <td class="r mono mudo" :title="o.usuario ? 'Lançado por ' + o.usuario : ''">{{ o.idOperacaoAplicacao }}</td>
                  </tr>
                  <tr v-if="!operacoesVisiveis.length">
                    <td colspan="7" class="ap-sem">{{ tiposMarcados.length ? 'Nenhuma operação destes tipos no período.' : 'Nenhuma operação no período.' }}</td>
                  </tr>
                  <tr class="ap-saldo-linha">
                    <td class="mono">{{ dataAteTexto }}</td>
                    <td colspan="4">Saldo atual</td>
                    <td class="r mono" :class="cor(extrato.saldoFinal)">{{ moeda(extrato.saldoFinal) }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="extrato" class="ap-resumo">
              <div class="ap-resumo-bloco">
                <div class="ap-resumo-tit">Resumo do período</div>
                <div class="ap-res"><span>Saldo anterior</span><b class="mono" :class="cor(extrato.saldoAnterior)">{{ moeda(extrato.saldoAnterior) }}</b></div>
                <div class="ap-res"><span>Aplicações (+)</span><b class="mono" :class="cor(extrato.aplicacoes)">{{ moeda(extrato.aplicacoes) }}</b></div>
                <div class="ap-res"><span>Resgates (−)</span><b class="mono" :class="cor(extrato.resgates)">{{ moeda(-extrato.resgates) }}</b></div>
                <div class="ap-res"><span>Rendimento bruto (+)</span><b class="mono" :class="cor(extrato.rendimentoBruto)">{{ moeda(extrato.rendimentoBruto) }}</b></div>
                <div class="ap-res"><span>Imposto de renda (−)</span><b class="mono" :class="cor(extrato.impostoRenda)">{{ moeda(-extrato.impostoRenda) }}</b></div>
                <div class="ap-res"><span>IOF (−)</span><b class="mono" :class="cor(extrato.iof)">{{ moeda(-extrato.iof) }}</b></div>
                <div v-if="Math.abs(extrato.outros) > 0.004" class="ap-res"><span>Outros (±)</span><b class="mono" :class="cor(extrato.outros)">{{ moeda(extrato.outros) }}</b></div>
                <div class="ap-res"><span>Rendimento líquido</span><b class="mono" :class="cor(extrato.rendimentoLiquido)">{{ moeda(extrato.rendimentoLiquido) }}</b></div>
                <div class="ap-res total"><span>Saldo atual =</span><b class="mono" :class="cor(extrato.saldoFinal)">{{ moeda(extrato.saldoFinal) }}</b></div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="ap-foot">
        <div class="ap-foot-info">
          <template v-if="extrato">{{ operacoesVisiveis.length }} {{ operacoesVisiveis.length === 1 ? 'operação' : 'operações' }} no período</template>
        </div>
        <div class="ap-acoes">
          <button type="button" class="btn btn-primary" :disabled="!extrato || carregandoExtrato" @click="exportar"><i class="fa fa-file-excel-o"></i> Exportar Excel</button>
          <button type="button" class="btn rd-sair" @click="$emit('fechar')"><i class="fa fa-times"></i> Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .ap-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.55); z-index: 2100; display: flex; align-items: center; justify-content: center; }
  .ap-modal { width: 1320px; max-width: 97vw; height: 90vh; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 16px 48px rgba(16,24,40,.35); overflow: hidden; }
  .ap-head { flex: 0 0 auto; padding: 14px 18px; border-bottom: 1px solid #eceef1; }
  .ap-head h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .ap-head small { display: block; color: #8a939c; font-size: 12px; margin-top: 3px; font-family: 'IBM Plex Mono', Consolas, monospace; }
  .ap-msg { text-align: center; padding: 40px; color: #8a939c; }
  .ap-erro { color: #a13c3c; }
  .ap-msg-corpo { flex: 1 1 auto; min-height: 0; }
  .ap-corpo { flex: 1 1 auto; min-height: 0; display: flex; }
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; font-variant-numeric: tabular-nums; }
  .mudo { color: #9aa3ac; }

  .ap-esq { flex: 0 0 360px; display: flex; flex-direction: column; border-right: 1px solid #dfe3e8; background: #fbfcfd; min-height: 0; }
  .ap-seg { flex: 0 0 auto; display: flex; gap: 6px; padding: 10px 12px; border-bottom: 1px solid #eceef1; }
  .ap-seg button { flex: 1; padding: 6px 10px; border: 1px solid #dfe3e8; border-radius: 6px; background: #fff; color: #5b6570; font-size: 12.5px; font-weight: 600; cursor: pointer; }
  .ap-seg button.ativo { background: #e8f5ef; border-color: #0f8a5f; color: #0a6d4d; }
  .ap-n { display: inline-block; min-width: 18px; padding: 0 5px; border-radius: 9px; background: #fff; border: 1px solid #dfe3e8; font-size: 10.5px; color: #5b6570; text-align: center; font-weight: 600; }
  .ap-lista { flex: 1 1 auto; min-height: 0; overflow: auto; padding: 8px; display: flex; flex-direction: column; gap: 6px; }
  .ap-vazio { padding: 24px 10px; text-align: center; color: #8a939c; font-size: 12.5px; }
  .ap-item { display: block; width: 100%; text-align: left; padding: 9px 11px; border: 1px solid #e3e7eb; border-radius: 6px; background: #fff; cursor: pointer; }
  .ap-item:hover { border-color: #b9dccd; background: #f7fcfa; }
  .ap-item.sel { border-color: #0f8a5f; background: #eef8f3; box-shadow: inset 3px 0 0 #0f8a5f; }
  .ap-item.inativa .ap-nome, .ap-item.inativa .ap-saldo { color: #8a939c; }
  .ap-item-l1 { display: flex; justify-content: space-between; align-items: baseline; gap: 8px; }
  .ap-nome { font-size: 13px; font-weight: 600; color: #1c2024; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .ap-saldo { font-size: 13.5px; font-weight: 600; color: #1c2024; white-space: nowrap; }
  .ap-item-l2 { font-size: 11.5px; color: #6b747e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-top: 2px; }
  .ap-item-l3 { font-size: 11px; color: #9aa3ac; margin-top: 2px; }
  .ap-chips { margin-top: 5px; display: flex; flex-wrap: wrap; gap: 4px; }
  .ap-fundos { flex: 0 0 auto; border-top: 1px solid #dfe3e8; padding: 10px 12px; background: #fff; max-height: 40%; overflow: auto; }
  .ap-fundos-tit { display: flex; justify-content: space-between; font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; margin-bottom: 6px; }
  .ap-fundos-vazio { font-size: 12px; color: #8a939c; }
  .ap-fundo-nome { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; }

  .ap-dir { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; min-height: 0; }
  .ap-sel { flex: 0 0 auto; padding: 10px 16px 8px; }
  .ap-sel-nome { font-size: 14.5px; font-weight: 600; color: #1c2024; }
  .ap-sel-info { font-size: 12px; color: #6b747e; margin-top: 2px; }
  .ap-filtros { flex: 0 0 auto; display: flex; align-items: flex-end; flex-wrap: wrap; gap: 8px 22px; padding: 2px 16px 10px; border-bottom: 1px solid #eceef1; }
  .ap-filtro { display: flex; flex-direction: column; gap: 4px; }
  .ap-lbl { font-size: 11px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; margin: 0; }
  .ap-lbl small { text-transform: none; letter-spacing: 0; font-weight: 400; color: #9aa3ac; }
  .ap-periodo, .ap-tipos { display: flex; align-items: center; gap: 6px; }
  .ap-a { color: #8a939c; font-size: 12px; }
  .ap-dt-box { display: inline-block; flex: 0 0 122px; width: 122px; }
  .ap-dt-box >>> .mx-datepicker { width: 100% !important; }
  .ap-dt-box >>> .ap-dt { height: 28px; font-size: 12.5px; padding: 4px 8px; }
  .ap-tipo { display: inline-flex; align-items: center; gap: 5px; height: 28px; padding: 0 10px; margin: 0; border: 1px solid #dfe3e8; border-radius: 14px; background: #fff; color: #5b6570; font-size: 12px; font-weight: 600; cursor: pointer; white-space: nowrap; }
  .ap-tipo input { margin: 0; }
  .ap-tipo.ativo { background: #e8f5ef; border-color: #0f8a5f; color: #0a6d4d; }
  .ap-tipo.vazio { opacity: .5; }

  .ap-extrato { flex: 1 1 auto; min-height: 0; overflow: auto; }
  .ap-tab { width: 100%; border-collapse: collapse; }
  .ap-tab.recarregando { opacity: .5; }
  .ap-tab th { position: sticky; top: 0; z-index: 1; background: #f7f9fa; font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; text-align: left; padding: 7px 10px; border-bottom: 1px solid #dfe3e8; white-space: nowrap; }
  .ap-tab th.r, .ap-tab td.r { text-align: right; }
  .ap-tab td { font-size: 12.5px; color: #34495e; padding: 6px 10px; border-top: 1px solid #f0f1f3; white-space: nowrap; vertical-align: middle; }
  .ap-tab tbody tr:nth-child(even) > td { background: #fbfcfd; }
  .ap-tab tbody tr:hover > td { background: #eaf5ff; }
  .ap-tab td.hist { max-width: 260px; overflow: hidden; text-overflow: ellipsis; }
  .ap-tab td.cred { color: #1c5fb8; }
  .ap-tab tbody tr > td.v-pos, .ap-saldo.v-pos, .ap-res b.v-pos { color: #1c5fb8; }
  .ap-tab tbody tr > td.v-neg, .ap-saldo.v-neg, .ap-res b.v-neg { color: #c0392b; }
  .ap-tab tbody tr > td.v-zero, .ap-saldo.v-zero, .ap-res b.v-zero { color: #9aa3ac; }
  .ap-tab td.deb { color: #c0392b; }
  .ap-tab tr.ap-saldo-linha > td { background: #f3f6f8; font-weight: 600; color: #1c2024; }
  .ap-sem { text-align: center; color: #8a939c; padding: 18px !important; }

  .ap-resumo { flex: 0 0 auto; display: flex; gap: 14px; padding: 10px 16px; border-top: 1px solid #dfe3e8; background: #fbfcfd; }
  .ap-resumo-bloco { flex: 0 0 340px; border: 1px solid #e3e7eb; border-radius: 6px; background: #fff; padding: 6px 12px 8px; }
  .ap-resumo-tit { font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: #7b848e; font-weight: 600; padding-bottom: 4px; margin-bottom: 3px; border-bottom: 1px solid #eceef1; }
  .ap-res { display: flex; justify-content: space-between; gap: 12px; font-size: 12px; color: #5b6570; line-height: 19px; }
  .ap-res b { color: #1c2024; font-weight: 600; }
  .ap-res.mudo b { color: #7b848e; font-weight: 500; }
  .ap-res.total { border-top: 1px solid #eceef1; margin-top: 3px; padding-top: 3px; font-weight: 600; color: #1c2024; }
  .ap-res.total.ok b { color: #0a6d4d; }
  .ap-res.total.dif b { color: #a13c3c; }

  .ap-foot { flex: 0 0 auto; display: flex; justify-content: space-between; align-items: center; padding: 12px 18px; border-top: 1px solid #dfe3e8; background: #f7f9fa; }
  .ap-foot-info { font-size: 13px; color: #5b6570; }
  .ap-acoes { display: flex; gap: 8px; }
  .rd-sair { background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; }
  .rd-sair:hover { background: #fbe7e7; border-color: #d9c2c2; color: #a13c3c; }
  .chip { display: inline-flex; align-items: center; font-size: 10.5px; font-weight: 600; border-radius: 10px; padding: 1px 8px; line-height: 16px; white-space: nowrap; border: 1px solid transparent; }
  .chip-cinza { color: #5b6570; background: #f1f3f5; border-color: #dfe3e8; }
  .chip-ambar { color: #8a5a00; background: #fdf3e0; border-color: #f0d9a8; }
  .chip-azul { color: #2b5b8c; background: #e8f1fb; border-color: #c2d8ef; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/AplicacoesContaModal.vue